import { map, mergeMap, catchError } from "rxjs/operators";
import { ofType } from "redux-observable";
import { pageTypesService } from "../../../common/services";
import * as actionTypes from "./actionTypes";
import * as pageTypesActions from "./actions";

export function fetchPageTypes(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_PAGE_TYPES),
    mergeMap(({ payload }) => {
      return pageTypesService.getPageTypes(payload).pipe(
        map((res) =>
          pageTypesActions.fetchPageTypesSuccess(res.responceObject.records)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
